import { IAdHocGroupProject, IAdHocProject, IGroupProject, IHatchetAiCompanyProjectOcr, IProject } from "../../models/applicationState";
import { AnyAction } from "../actions/actionCreators";
import { ActionTypes } from "../actions/actionTypes";

export const reducer = (state: IAdHocGroupProject = null, action: AnyAction): IAdHocGroupProject => {
    switch(action.type) {
        case ActionTypes.AD_HOC_OCR_GROUP_LOAD_PROJECT: {
            let grp = action.payload.adHocProjectModels;
            let groupProject: IAdHocProject[] = [];
            grp.forEach(g => {
                const p = JSON.parse(g.project);
                g.project = p;
                groupProject.push(JSON.parse(JSON.stringify(g)));                
            });
            return { 
                ...state,
                adhocGroupProjects: groupProject,
                adHocProjectProjectResults: action.payload.adHocProjectModels
            };
            break;
        }
        case ActionTypes.SET_GENERATE_MODEL_GROUP: {
            return {
                ...state, 
                generateModelGroup: action.payload
            }
        }
        default: {
            return state;
        }
    }
}